import React from 'react';
import {
  SetupAssistant,
  SetupAssistantStep,
  Button,
  Modal,
  ProgressBar,
} from '@salesforce/design-system-react';

const AstroWelcome = (props) => {
  function openQuestionnaire() {
    window.open('https://salesforce.quip.com/nLb2AnTpluED');

    props.updateChecklistOne();
  }

  return (
    <React.Fragment>
      <div className="slds-align_absolute-center" key="checklist-div">
        <Modal
          key="checklist-modal"
          size="small"
          disableClose
          isOpen={true}
          footer={[
            <Button label="Cancel" onClick={() => props.closeAstro()} />,
            <Button
              label="Go To Journey"
              variant="brand"
              onClick={() => props.nextScreen()}
            />,
          ]}
        >
          <SetupAssistant
            id="step-progress-setup-assistant"
            key="step-progress-setup-assistant"
            isCard
            progressBar={
              <ProgressBar
                color="success"
                id="card-setup-assistant-progress-bar"
                labels={{
                  label: 'Complete all the Hero6 Prework step below',
                }}
                radius="circular"
                value={props.checklistOne === false ? 0 : 100}
                variant="light"
              />
            }
          >
            <SetupAssistantStep
              description="Generate Hero6 Questionnaire and share with account team and internal stakeholders."
              estimatedTime="45 mins"
              heading="Hero6 Questionnaire"
              id="step-progress-step-1"
              key="step-progress-step-1"
              onRenderAction={
                !props.isCollaborator
                  ? () => (
                      <Button
                        className="slds-p-around_medium"
                        id="step-progress-step-1-action-questionnaire"
                        key="step-progress-step-1-action-questionnaire"
                        label="Questionnaire"
                        variant="link"
                        onClick={openQuestionnaire}
                      />
                    )
                  : null
              }
              progress={props.checklistOne === false ? 0 : 100}
            />
            {/**  
            <SetupAssistantStep
              description="Copy Questionnaire into the Hero6 Business Challenge View and the Hero6 Personas View."
              estimatedTime="15 mins"
              heading="Add Business Challenge and Personas to Hero6 Journey"
              id="step-progress-step-2"
              key="step-progress-step-2"
              onRenderAction={
                !props.isCollaborator
                  ? () => (
                      <Button
                        id="step-progress-step-2-action"
                        key="step-progress-step-2-action"
                        label="Mark as Completed"
                        variant="brand"
                        onClick={() => props.updateChecklistTwo()}
                      />
                    )
                  : null
              }
              progress={props.checklistTwo === false ? 0 : 100}
            />
            */}
          </SetupAssistant>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default AstroWelcome;
